export default __webpack_public_path__ + "static/media/ico-trash.07a9c950.svg";